module.exports = __webpack_public_path__ + "static/media/empty.f335d610.svg";